module.exports = __webpack_public_path__ + "static/media/iframe-cc.454dafbe.jpg";